import {
  formAccentColor,
  shouldShowTenantLogo,
} from './formBuilderModel'

/**
 * Tenant logo for the page chrome (outside the white form card).
 * Returns null when logo is not enabled.
 */
export function FormTenantLogo({ settings, branding, darkPage = false }) {
  const showLogo = shouldShowTenantLogo(settings)
  if (!showLogo) return null
  const logoSrc = branding?.logoUrl || branding?.brandmarkUrl || null
  if (logoSrc) {
    return (
      <img
        src={logoSrc}
        alt=""
        className="mb-4 h-12 max-w-[220px] object-contain object-left"
      />
    )
  }
  return (
    <div
      className={`mb-4 text-xs font-semibold uppercase tracking-wide ${
        darkPage ? 'text-teal-200' : 'text-teal-700'
      }`}
    >
      PaySafeGO
    </div>
  )
}

/**
 * Form title inside the white card (stays dark-on-white for contrast).
 */
export default function FormBrandingHeader({ formName, subjectLabel, titleExtra }) {
  if (!formName && !subjectLabel) return null
  return (
    <div className="mb-4">
      {formName ? (
        <h1 className="text-2xl font-semibold text-slate-900 mb-1">
          {formName}
          {titleExtra}
        </h1>
      ) : null}
      {subjectLabel ? (
        <p className="text-sm text-slate-500">For {subjectLabel}</p>
      ) : null}
    </div>
  )
}

export function formSubmitButtonStyle(settings, branding) {
  const accent = formAccentColor(settings, branding)
  return {
    backgroundColor: accent,
    borderColor: accent,
  }
}
